//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import util from '@/libs/util'
	import {_} from '@/libs/util'
	import common from '@/libs/common.mixin'
	import VueVideo from 'c%/vueVideo.vue'
	import VueDPlayer from '@/libs/dplayer'
	
	export default{
		mixins: [ common ],
		components: {
			VueVideo,
			'd-player': VueDPlayer
		},
		data () {
			return {
				isPlay: false
			}
		},
		props: {
			item: {
				type: Object,
				default: ()=>{
					return {}
				}
			}
		},
		computed: {
			sources () {
				let item = this.item,
					result = []
				if(!_.isEmpty(item)){
					result = [{
						src: item.file_url,
						size: item.file_size,
						type: 'video/mp4'
					}]
				}
				return result
			},
			doptions() {
				let result = {
					video: {
						url: '',
						pic: ''
					},
					autoplay: false
				}
				result.video.pic = this.item.file_url+'?vframe/jpg/offset/1'
				result.video.url = this.item.file_url
				return result
			},
			file_name() {
				let splits = this.item.file_url.split('/')
				return splits[splits.length-1]
			}
		},
		methods: {
			play () {
				this.isPlay = !this.isPlay
				this.$refs.video.play()
			},
			getSource (item) {
				return [{
					src: item.file_url,
					size: item.file_size,
					type: 'video/mp4'
				}]
			},
			getVOptions (item) {
				return {
					autoplay: false,
			        volume: 0.6,
			        poster: item.src+'?vframe/jpg/offset/1'				
				}
			},
			getDuration (item) {			
				let duration = Math.ceil(item.duration)
				return util.second_to_minute(duration)				
			},
			downloadVideo() {
				if(this.isIOS) {
					this.alert('提示','由于苹果的限制，请用电脑登录下载')
					return
				}
				var a = document.createElement('a')
			    a.style.display = 'none'
			    a.setAttribute('href',this.item.file_url+'?attname='+this.file_name)
			    a.setAttribute('download','download')
			    a.click()
            },
            copyVideo(){
                let input = document.createElement("input")
                input.readOnly = 'readonly'
                input.value = this.item.file_url
                document.body.appendChild(input)
                input.select()
                input.setSelectionRange(0, input.value.length)
                document.execCommand('Copy')
                document.body.removeChild(input)
                this.alert('提示','复制成功，请用第三方浏览器打开下载！')
            }
		}
	}



// WEBPACK FOOTER //
// ./src/components/FileItemVideo.vue